import { combineReducers } from '@reduxjs/toolkit';
import { reducer as getEmployeesSchecule } from './model/getEmployeesSchedule';
import { reducer as substitutionsScheduleSlice } from './model/substitutionsScheduleSlice';
import { reducer as multiSelectSubtitution } from './model/multiSelectSubtitution';

export * as VacationsScheduleModel from './model';

const vacationsScheduleReducer = combineReducers({
  employeesSchedule: getEmployeesSchecule,
  substitutionsSchedule: substitutionsScheduleSlice,
  multiSelectSubtitution,
});

export default vacationsScheduleReducer;
